import React from 'react';
import { Camera, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="fixed top-0 z-50 w-full backdrop-blur-xl bg-white/60 shadow-sm border-b border-white/20 transition-all duration-300 pointer-events-none">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center max-w-6xl pointer-events-auto">
        <Link to="/" className="flex items-center space-x-3 group">
          <div className="flex items-center justify-center bg-gradient-to-br from-indigo-500 to-purple-600 p-2.5 rounded-xl shadow-lg group-hover:scale-105 transition-transform duration-300">
            <Camera className="text-white h-6 w-6 stroke-[2.5]" />
          </div>
          <span className="text-2xl font-black bg-clip-text text-transparent bg-gradient-to-r from-slate-900 via-indigo-800 to-slate-900 tracking-tight">
            Pass-Photo
          </span>
        </Link>
        <nav className="hidden md:flex space-x-8 items-center text-sm font-semibold text-slate-600">
          <button onClick={() => window.scrollTo(0,0)} className="hover:text-indigo-600 transition-colors">Start Generating</button>
      <Link to="/about" className="hover:text-indigo-600 transition-colors">
    About </Link>
          <button onClick={() => window.scrollTo({ top: 300, behavior: 'smooth' })} className="flex items-center gap-2 bg-slate-900 text-white px-5 py-2.5 rounded-full hover:bg-indigo-600 hover:shadow-lg hover:shadow-indigo-500/30 transition-all duration-300 font-bold active:scale-95">
            <Sparkles className="w-4 h-4" /> Try for Free
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
